export const PROXY_MANAGER_PERMISSION_RESOURCE = 'proxy-manager';

// Quarantine levels considered terminal — only these can be reset.
export const QUARANTINED_LEVELS: string[] = ['permanent', 'dead'];
